import React from "react";
import "./Terms_Conditions.css";

const Terms_Conditions = () => {
  return (
    <section className="Terms_Conditions Privacy_Policy">
      <div className="privacy_banner">
        <p className="banner_text">Terms and Conditions</p>
      </div>
      <div className="container">
        <div className="card card_div">
 

          <section class="terms-of-use">

            <p>
              These Terms of Use ("Terms") govern your access to and use of the website located at &nbsp;
              <a href="https://afiway.com">https://afiway.com</a> (the "Site") and any features, content,
              or services made available through the Site (collectively, the "Services").
              The Site and Services are operated by Ambassadeur Francophone Inc.
              ("Company," "we," "us," or "our").
            </p>

            <p>
              <strong>BY ACCESSING OR USING THE SITE OR SERVICES, YOU AGREE TO BE BOUND BY THESE TERMS.
                IF YOU DO NOT AGREE, DO NOT USE THE SITE OR SERVICES.</strong>
            </p>

            <p>
              <strong>IMPORTANT:</strong> THESE TERMS CONTAIN A BINDING ARBITRATION AGREEMENT AND
              CLASS ACTION WAIVER IN SECTION 12. PLEASE READ CAREFULLY.
            </p>

            <h2>1. Eligibility and Account Registration</h2>
            <p>
              You must be at least 18 years old to use the Site or Services. If you use the Site or
              Services on behalf of an entity, you represent that you have authority to bind that entity.
            </p>
            <h3>Account Creation</h3>
            <p>
              Some features may require you to create an account ("Account"). When you create an
              Account, you agree to provide accurate, current, and complete information and to keep it updated.
            </p>

            <h3>Account Security</h3>
            <p>
              You are responsible for maintaining the confidentiality of your login credentials and for
              all activity that occurs under your Account. Notify us immediately of any unauthorized use
              or security breach.
            </p>

            <h2>2. License and Acceptable Use</h2>
            <p>
              Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable
              license to access and use the Site for your personal, non-commercial use.
            </p>

            <h3>Restrictions</h3>
            <ul>
              <li>Do not copy, modify, distribute, sell, lease, or exploit any portion of the Site or Services unless expressly authorized by us.</li>
              <li>Do not reverse engineer, decompile, or attempt to derive source code from the Site or Services.</li>
              <li>Do not access the Site to build or benchmark a competing product or service.</li>
              <li>Do not interfere with or disrupt the integrity or performance of the Site (including scraping, automated access, or circumvention of access controls).</li>
              <li>Do not use the Site for unlawful, harmful, fraudulent, misleading, or abusive purposes.</li>
            </ul>

            <h2>3. User Content</h2>
            <p>
              "User Content" means any content you submit, upload, transmit, or otherwise make available
              through the Site or Services.
            </p>

            <h3>Your Responsibilities</h3>
            <p>
              You are solely responsible for your User Content and for ensuring that your User Content
              complies with applicable law and these Terms. We may remove User Content and suspend or
              terminate Accounts as described in Section 9.
            </p>

            <h3>License to Company</h3>
            <p>
              You grant Company a worldwide, non-exclusive, royalty-free, fully paid, sublicensable
              license to host, store, reproduce, modify (for technical formatting), display, and distribute
              your User Content solely to operate, provide, maintain, and improve the Site and Services.
            </p>

            <h2>4. Intellectual Property</h2>
            <p>
              The Site, Services, and all related content and materials (excluding User Content) are owned
              by Company or its licensors and are protected by U.S. and international intellectual property laws.
              No rights are granted to you except as expressly stated in these Terms.
            </p>
            <p>
              All trademarks, logos, and service marks displayed on the Site are the property of Company
              or their respective owners. You may not use them without prior written permission.
            </p>

            <h2>5. Feedback</h2>
            <p>
              If you submit ideas, suggestions, or feedback, you agree that we may use them without
              restriction or compensation to you.
            </p>

            <h2>6. Third-Party Services and Links</h2>
            <p>
              The Site may include third-party links, integrations, or services. We do not control third
              parties and are not responsible for their content, policies, or practices. Your use of
              third-party services is at your own risk and subject to their terms.
            </p>

            <h2>7. Disclaimers</h2>
            <p>
              <strong>THE SITE AND SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE".</strong>
              To the maximum extent permitted by law, we disclaim all warranties, whether express,
              implied, or statutory.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Company’s total liability for any claim arising
              out of or related to these Terms or the Site or Services will not exceed <strong>USD $50</strong>.
            </p>

            <h2>9. Termination</h2>
            <p>
              We may suspend or terminate your access to the Site or Services at any time if we reasonably
              believe you have violated these Terms or must do so to comply with law.
            </p>

            <h2>10. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless Company and its affiliates from any claims
              arising from your use of the Site, your User Content, or your violation of these Terms.
            </p>

            <h2>11. Governing Law and Venue</h2>
            <p>
              These Terms are governed by the laws of the State of Washington, without regard to conflict
              of laws principles.
            </p>

            <h2>12. Arbitration Agreement and Class Action Waiver</h2>
            <p>
              <strong>PLEASE READ THIS SECTION CAREFULLY.</strong> It affects your rights.
            </p>

            <h3>Class Action Waiver</h3>
            <p>
              YOU AND COMPANY AGREE THAT EACH MAY BRING CLAIMS ONLY IN AN INDIVIDUAL CAPACITY AND NOT
              AS A CLASS MEMBER.
            </p>

            <h2>13. DMCA Copyright Policy</h2>
            <ul>
              <li>Your physical or electronic signature</li>
              <li>Identification of the copyrighted work</li>
              <li>Identification of the infringing material</li>
              <li>Your contact information</li>
              <li>A good-faith statement</li>
              <li>A statement under penalty of perjury</li>
            </ul>

            <h2>14. Contact and Notices</h2>
            <p>
              <strong>Ambassadeur Francophone Inc.</strong><br></br>
              710 Seneca St Ste 107, Seattle, Washington 98101<br></br>
              Phone: +1 202-902-8824<br></br>
              Email: <a href="mailto:contact@afiway.com">contact@afiway.com</a><br></br>
              DMCA: <a href="mailto:dmca@afiway.com">dmca@afiway.com</a>
            </p>

            <h2>15. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the Site constitutes acceptance.
            </p>

            <h2>16. Miscellaneous</h2>
            <ul>
              <li>Severability</li>
              <li>Assignment</li>
              <li>Entire Agreement</li>
              <li>No Waiver</li>
              <li>Electronic Communications</li>
              <li>Export Compliance</li>
            </ul>

            <p>
              <strong>Copyright © 2026 Ambassadeur Francophone Inc. All rights reserved.</strong>
            </p>

          </section>

        </div>
      </div>
    </section>
  );
};

export default Terms_Conditions;
